app
    .controller('CancelAndRefundCtrl', function ($http, $scope, $window) {

        $scope.description = 'Lack of time.';

        this.cancel = () => {
            this.dismiss();
        };

        this.confirm = () => {
            this.loading = true;
            $http.post(`/orders/cancel/${this.resolve.serviceId}`, {description: $scope.description}).then((response) => {
                // console.log(response);
                if (response.data.status == 'success') {
                    $window.location.href = '/profile';
                } else {
                    alert(response.data.message);
                    // this.close();
                }
            }).finally(() => {
                this.loading = false;
            });
        };

        this.$onInit = () => {
        };
    })
    .component('cancelAndRefund', {
        template: `
        <div style="width: 100%; min-width: 32vw;padding:20px;">
            <div class="modal-header  header p-1 mb-3">
                <h1 style="font-size: 24px; font-family: 'goboldregular', Impact, sans-serif;margin: 10px auto; text-align: center;">{{ 'modal.refund.title' | translate }}</h1>
                <button class="btn btn-close" ng-click="$ctrl.cancel()">
                    <chat-icon type="cross" width="15" />
                </button>
            </div>
            <div class="body text-center">
                <div>{{ 'modal.refund.line1' | translate }} <br>
                {{ 'modal.refund.line2' | translate }}</div>
                <div><b>{{ 'modal.refund.from' | translate }} {{$ctrl.resolve.userName}}</b></div>
                <div>{{ 'modal.refund.line3' | translate }}<br>
                {{ 'modal.refund.line4' | translate }}</div>
                <div class="form-group row mt-2">
                    <div class="col-12">
                        <textarea ng-model="description" rows="6" class="form-control" placeholder=""></textarea>
                    </div>
                </div>
            </div>
            <div class="footer text-center mb-2 mt-4">
                <i class="fa fa-spinner fa-spin" ng-if="$ctrl.loading"></i> <br/>
                <button class="btn btn-green font-go-bold btn-200 mb-2" ng-click="$ctrl.confirm()">
                    {{ 'modal.refund.confirmRefund' | translate }} <br>
                    {{ 'modal.refund.confirmRefundLine2' | translate }}                    
                </button><br>
                <button class="btn btn-reject btn-slim font-go-bold btn-200 py-2" ng-click="$ctrl.cancel()">
                    {{ 'modal.refund.cancel' | translate }}
                </button>
            </div>
        </div>
        `,
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        },
        controller: 'CancelAndRefundCtrl'
    });
